<div class="confirmation-dialog" data-test="confirmation-dialog">
  <div class="dialog-header">
    <h1 data-test="confirmation-dialog-title">
      {{ title }}
    </h1>
    <button
      [mat-dialog-close]="false"
      aria-label="close dialog"
      data-test="close-button"
      mat-icon-button>
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>
  <div class="dialog-body">
    <div data-test="confirmation-dialog-text" class="dialog-text">
      <p [innerHTML]="text"></p>
    </div>
    <mat-divider></mat-divider>
    <div class="confirmation-dialog-actions">
      <button
        [mat-dialog-close]="false"
        data-test="confirmation-dialog-cancel-button"
        mat-stroked-button
        class="cta-button"
        color="accent">
        {{ cancelButtonText }}
      </button>
      <button
        [mat-dialog-close]="true"
        class="cta-button float-right"
        color="primary"
        data-test="confirmation-dialog-ok-button"
        mat-flat-button>
        {{ confirmButtonText }}
      </button>
    </div>
  </div>
</div>
